import { DurationPriceOptionItem } from "./types";

export const getInitialDurationPriceValue = (options: DurationPriceOptionItem[]): DurationPriceOptionItem | null => {
  if (options.length <= 0) return null;
  return options.reduce<DurationPriceOptionItem>((acc, p) => {
    return (acc?.meta?.duration ?? 0) <= (p?.meta?.duration ?? 0) ? acc : p;
  }, options[0]).value;
};
